import { Link,useNavigate,useParams } from "react-router-dom"
import DashboardSideBar from "../../components/dashboardSidebar"
import Footer from "../../components/footer"
import Header from "../../components/header"
import SideBar from "../../components/sidebar"
import { useEffect, useState } from "react"
import services from "../../services"
import constant from "../../constant";
import Toaster from "../../components/toaster";
import "react-toggle/style.css" // for ES6 modules
import Toggle from 'react-toggle'
import useIsMobile from "../../hooks/useIsMobile";
import MobileHeader from "../../components/MobileHeader";
import CitySelect from "../../components/CitySelect";
const EditCar = ()=>{
    let navigate = useNavigate();
    const isMobileView = useIsMobile();
    const [carsList, setCarsList] = useState()
    const [citiesList, setCitiesList] = useState([])
    const [carData, setCarData] = useState()
    const [driverList, setDriverList] = useState()
    const [selectedDriver, setSelectedDriver] = useState()

    const [isAcAvailable, setIsAcAvailable] = useState(false)
    const [isCarrierAvailable, setIsCarrierAvailable] = useState(false)
    const [toaster, setToaster] = useState({ visiblity: "hide" });
    let { id } = useParams();
    const getMasterCars = async() =>{
        try {
            const response = await services.Cars.GET_CAR();
            console.log(response)
            setCarsList(response.data)
        } catch (error) {
            console.log(error)
        }
    }
    const getCarDetail = async(id) =>{
        try {
            const response = await services.Cars.GET_VENDOR_CAR_ID(id);
            console.log(response)
            setCarData(response.data)
            setIsAcAvailable(response.data.isAcAvailable == null ? false : response.data.isAcAvailable)
            setIsCarrierAvailable(response.data.isCarrierAvailable == null ? false : response.data.isCarrierAvailable)
        } catch (error) {
            console.log(error)
        }
    }
    const getCities = async() =>{
        try {
            const response = await services.Cars.GET_CITIES();
            setCitiesList(response.data || [])
        } catch (error) {
            console.log(error)
        }
    }
    const handleCitySelect = (cid) => {
        const c = (citiesList || []).find((x) => String(x.id) === String(cid));
        setCarData((prev) => ({ ...prev, cityId: c ? c.id : null, cityName: c ? c.name : '' }));
    }
    const HandleOnChangeValue = (e, key) => {
        let obj = { ...carData }
            obj[key] = e;
        setCarData({ ...obj })
    }
    const getDriverData = async() =>{
        try {
            const response = await services.Vendor.GET_DRIVER();
            console.log(response)
            setDriverList(response.data)
        } catch (error) {
            console.log(error)
        }
    }
    const uploadBusinessImage = async (e, type) => {
        const formData = new FormData();
        let categoryImage = e.target.files[0];
        formData.append("file", categoryImage);

        try {
            const response = await services.Cars.UPLOAD_IMAGE(formData);
            console.log(response)
            if (type == 'car') {
                // Replace the existing photo instead of appending a second one.
                HandleOnChangeValue([response.data.url], 'photos')
            } else {
                let arr = carData.docs || []
                arr.push(response.data.url)
                HandleOnChangeValue(arr, 'docs')
            }
        } catch (error) {
            console.log(error);
        }

    };
    const onSubmitHandler = async() =>{
        try {
            // Only the photos can be changed once a car is added; support changes anything else
            let payload = {
               carData : { photos: carData.photos }
            }
            const response = await services.Cars.UPDATE_CAR(id, payload);
            console.log(response)
            setToaster({
                type: "success",
                title: "Car updated",
                text: 'Car photos updated successfully',
                visiblity: "show",
            });
            setTimeout(()=>{
            navigate('/cars')

            },300)
        } catch (error) {
            console.log(error)
            setToaster({
                type: "danger",
                title: "Error Occured",
                text: error.response.data.message,
                visiblity: "show",
            });
            setTimeout(() => {
                setToaster({
                    visiblity: "hide",
                });

            }, 1500)
        }
    } 
    useEffect(()=>{
        getMasterCars();
        getCities();
        // getDriverData();
        getCarDetail(id);
    },[])
    if (isMobileView) {
        return (
            <>
                <Toaster type={toaster.type} title={toaster.title} text={toaster.text} visiblity={toaster.visiblity} />
                <SideBar />
                <main className="mlux mlux-auth">
                    <MobileHeader back={`/car/${id}`} />
                    <div className="mlux-greet" style={{ margin: '8px 4px 2px' }} data-rise="1">
                        <div className="kick">Update details</div>
                        <div className="nm" style={{ fontSize: 24 }}>Edit Car</div>
                    </div>
                    <div className="mlux-card" style={{ padding: 16, marginTop: 12 }} data-rise="2">
                        <div className="mlux-note"><i className="fas fa-lock"></i> Only car photos can be changed. Contact Cars53 support to change other details.</div>
                        <label className="mlux-lbl">Car model</label>
                        <div className="mlux-field no-icon select"><select disabled value={carData?.carId || ''} onChange={(e) => HandleOnChangeValue(e.target.value, 'carId')}><option value="">Select car</option>{carsList && carsList.length && carsList.map((c, i) => <option key={i} value={c.id}>{c.name}</option>)}</select></div>
                        <label className="mlux-lbl">City of origin</label>
                        <CitySelect variant="mobile" icon="far fa-location-dot" disabled cities={citiesList} value={carData?.cityId} onChange={handleCitySelect} />
                        <div className="mlux-row">
                            <div><label className="mlux-lbl">Model year</label><div className="mlux-field no-icon"><input type="text" disabled value={carData?.year || ''} placeholder="2022" /></div></div>
                            <div><label className="mlux-lbl">Per km (₹)</label><div className="mlux-field no-icon"><input type="text" disabled value={carData?.perKmCharge || ''} placeholder="₹ per km" /></div></div>
                        </div>
                        <label className="mlux-lbl">RC number</label>
                        <div className="mlux-field no-icon"><input type="text" disabled value={carData?.rcNumber || ''} placeholder="MP09XX0000" /></div>
                        <div className="mlux-switch" style={{ marginTop: 10 }}>
                            <div className="lb"><i className="far fa-snowflake"></i> AC available</div>
                            <button type="button" disabled className={`mlux-sw ${isAcAvailable ? 'on' : ''}`}></button>
                        </div>
                        <div className="mlux-switch">
                            <div className="lb"><i className="far fa-suitcase-rolling"></i> Luggage carrier</div>
                            <button type="button" disabled className={`mlux-sw ${isCarrierAvailable ? 'on' : ''}`}></button>
                        </div>
                        <label className="mlux-lbl">Car photos</label>
                        <div className="mlux-field no-icon"><input type="file" onChange={(e) => uploadBusinessImage(e, 'car')} style={{ paddingTop: 14, height: 'auto' }} /></div>
                        {carData?.photos?.length > 0 && <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 10 }}>{carData.photos.map((p, i) => <img key={i} src={constant.IMAGE_URL + p} crossOrigin="anonymous" alt="" style={{ width: 70, height: 70, objectFit: 'cover', borderRadius: 10, border: '1px solid var(--hairline)' }} />)}</div>}
                        <label className="mlux-lbl">Documents (locked)</label>
                        {carData?.docs?.length > 0 && <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 10 }}>{carData.docs.map((p, i) => <img key={i} src={constant.IMAGE_URL + p} crossOrigin="anonymous" alt="" style={{ width: 70, height: 70, objectFit: 'cover', borderRadius: 10, border: '1px solid var(--hairline)' }} />)}</div>}
                        <button className="mlux-btn" style={{ marginTop: 10 }} onClick={onSubmitHandler}><i className="far fa-circle-check"></i> Save photos</button>
                    </div>
                </main>
            </>
        );
    }

    return (<>
        <Header/>
        <SideBar/>
            <main class="main">
    
            <Toaster
                type={toaster.type}
                title={toaster.title}
                text={toaster.text}
                visiblity={toaster.visiblity}
            />
    
    
            <div class="user-profile py-5">
                <div class="container">
                    <div class="row">
                       <DashboardSideBar/>
                        <div class="col-lg-9">
                            <div class="user-profile-wrapper">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="user-profile-card">
                                            <div class="user-profile-card-header">
                                                <h4 class="user-profile-card-title">Edit Car</h4>
                                             
                                            </div>
                                            <div class="user-profile-form">

                                                <div class="row">
                                                <div class="col-md-12">
                                                    <p className="text-muted"><i className="far fa-lock"></i> Only car photos can be changed. Contact Cars53 support to change other details.</p>
                                                </div>
                                                <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Select Car</label>
                                                           <select disabled value={carData?.carId} onChange={(e)=>HandleOnChangeValue(e.target.value, 'carId')}  class="form-control">
                                                                <option>Select</option>
                                                                {carsList && carsList.length && carsList.map((item)=> {return (
                                                                     <option value={item.id}>{item.name}</option>
                                                                )})}
                                                           </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>City of Origin</label>
                                                            <CitySelect disabled cities={citiesList} value={carData?.cityId} onChange={handleCitySelect} />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Car Model Year</label>
                                                            <input type="text" disabled class="form-control" value={carData?.year}
                                                                placeholder="Car Model Year" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Car RC Number</label>
                                                            <input type="text" disabled class="form-control" value={carData?.rcNumber}
                                                                placeholder="Car RC Number" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Per Km Charge (without AC)</label>
                                                            <input type="text" disabled class="form-control" value={carData?.perKmCharge}
                                                                placeholder="₹ per km" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 align-items-center d-flex">
                                                        <div class="form-group mb-0">
                                                            <label class="align-items-center d-flex gap-2" >
                                                               
                                                                <Toggle
                                                                    disabled
                                                                    checked={isAcAvailable} />
                                                                <span>Air Conditioner</span>
                                                            </label>
                                                            <label class="align-items-center d-flex gap-2" >
                                                                <Toggle
                                                                    disabled
                                                                    checked={isCarrierAvailable} />
                                                                <span>Carrier</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    {/* <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Select Driver</label>
                                                           <select onChange={(e)=>setSelectedDriver(e.target.value)}  class="form-control">
                                                                <option>Select</option>
                                                               {carData?.DriverCar?.id && <option value={'remove'}>Remove Driver</option>}
                                                                {driverList && driverList.length && driverList.map((item)=> {return (
                                                                     <option value={item.id}>{item.firstName} {item.lastName}</option>
                                                                )})}
                                                           </select>
                                                        </div>
                                                    </div> */}
                                                    <div class="col-md-12">
                                                        <div class="form-group">
                                                            <label>Car Photos</label>
                                                            <input onChange={(e) => uploadBusinessImage(e, 'car')} type="file" class="form-control"
                                                                placeholder="Car Photos" />
                                                        </div>
                                                        {carData?.photos && carData?.photos.length && carData?.photos.map((item)=>{return (
                                                            <img style={{maxHeight: '200px'}} crossorigin="anonymous" src={constant.IMAGE_URL + item} />
                                                        )})
                                                            
                                                        }
                                                    </div>
                                                    <div class="col-md-12">
                                                        <div class="form-group">
                                                            <label>Documents (locked)</label>
                                                        </div>
                                                        {carData?.docs && carData?.docs.length && carData?.docs.map((item)=>{return (
                                                            <img style={{maxHeight: '200px'}} crossorigin="anonymous" src={constant.IMAGE_URL + item} />
                                                        )})
                                                            
                                                        }
                                                    </div>
                                                  
                                                </div>
                                                <button type="button" onClick={onSubmitHandler}  class="theme-btn my-3"><span
                                                    class="far fa-user"></span> Save Photos</button>

                                            </div>
    
                                          
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
        </main>
        <Footer/>
        </>
        )
}
export default EditCar